import { UnauthenticatedTemplate, useMsal, AuthenticatedTemplate} from "@azure/msal-react";
import Login from "../pages/authentication/components/Login";
import React, {useEffect, useState} from "react";
import NavigationHeader from "./organisms/Navigation/NavigationHeader";
import Loader from "./atoms/Loader/Loader";
import {useNavigate} from "react-router-dom";
import Footer from "./templates/Footer/Footer";
import UseAuthConfig from "../hooks/useAuthConfig";
import { useOrganisationStatus } from "../context/organisationStatus";
export const PageLayout = (props) => {
    const [isLoading, setIsLoading] =  useState(false);
    const { isLoading: isOrganisationStatusLoading } = useOrganisationStatus();
    const { accounts, inProgress, instance } = useMsal();
    const { protectedResources } = UseAuthConfig();
    let navigate = useNavigate();
    useEffect(()=>{
        if (inProgress === 'startup' || inProgress === 'handleRedirect'){
            setIsLoading(true);
        }else if (inProgress === 'none') {            
            setIsLoading(false);
        }else if (inProgress === 'logout'){
            localStorage.clear();
        }
        if (accounts.length > 0) {
            const account = accounts[0];
            const expiresOn = new Date(account.idTokenClaims.exp * 1000); // Expiry time in seconds since 1970-01-01T00:00:00Z

            if (expiresOn < new Date()) {
                localStorage.clear();
                navigate('/')
                instance.logoutRedirect();
            } else {
                // Access token is still valid
            }
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[inProgress]);


    useEffect(() => {
        const fetchAccessToken = async () => {
            try {
                const loginRequest = {
                    scopes: [
                        ...protectedResources.apiTodoList.scopes.read,
                        ...protectedResources.apiTodoList.scopes.write,
                    ],
                };
                const response = await instance.acquireTokenSilent(loginRequest);
                localStorage.setItem("AccessToken", response?.accessToken);
            } catch (error) {
                console.error("Access Token Fetch Failed:", error);
            }
        };

        if (accounts.length > 0) {
            fetchAccessToken();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [accounts, instance]);


    return (
        <>

            <>
                <NavigationHeader/>
                {
                    ( isLoading ?  <Loader/> :  props.children )
                }

                {/* <UnauthenticatedTemplate>
                    <Login/>
                    <Footer />
                </UnauthenticatedTemplate> */}
              <AuthenticatedTemplate>
              {/* Wait for the organisation status so the footer doesn't render beside the loader. */}
              {!isOrganisationStatusLoading && <Footer />}
              </AuthenticatedTemplate>
              
            </>
        </>
    );
}
